import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 3rem;
`;

export const Container2 = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto 40px auto;
  gap: 20px;
`;

export const Grid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(270px, 1fr));

  @media screen and (max-width: 700px) {
    grid-template-columns: repeat(1, minmax(270px, 1fr));
  }

  @media screen and (max-width: 314px) {
    grid-template-columns: repeat(1, minmax(230px, 1fr));
  }
`;

export const SessionTitle = styled.div`
  width: 100%;
  background: #5291b2;
  padding: 5px 3rem;
  margin-bottom: 20px;

  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #fff;
`;
